(function () {
	angular.module('app')
		.controller('CaseStudyController', CaseStudyController)

	CaseStudyController.$inject = ['$rootScope', '$scope', '$attrs', 'caseStudyResource', '$location', '$timeout'];
	function CaseStudyController($rootScope, $scope, $attrs, caseStudyResource, $location, $timeout) {
		var ctrl = this;
		ctrl.services = [];
		ctrl.selectedService = null;
		ctrl.selectedIndustry = null;
		ctrl.industries = [];
		var hash = $location.hash();

		caseStudyResource.services.get({ id: $attrs.id }, function (data) {
		    ctrl.services = data.items;
		    
		    if (ctrl.services != null && hash !== null) {
		        angular.forEach(ctrl.services, function (value, key) {
		            if (value.urlName == hash) {
		                $timeout(function () {
		                    ctrl.selectedService = value;
		                    $rootScope.params.services = value.id;
		                    angular.element('#case-study-search-service').val(ctrl.selectedService.id);
		                }, 1000);
		            }
		        });
		    }
		})

		/*caseStudyResource.industries.get({ id: $attrs.id }, function (data) {
		    ctrl.industries = data.items;
		})*/
        
		$scope.$watch('selectedService', function (newVal) {
		    if (newVal) {
		        $rootScope.params.services = newVal.id;
		    }
		    else {
		        $rootScope.params.services = null;
		    }
		})

		$scope.$watch('selectedIndustry', function (newVal) {
		    if (newVal) {
		        $rootScope.params.industries = newVal.id;
		    }

		    else {
		        $rootScope.params.industries = null;
		    }
		})

		ctrl.startOverClick = function () {
		    ctrl.selectedService = null;
		    ctrl.selectedIndustry = null;
		    $rootScope.params.services = null;
		    $rootScope.params.industries = null;

		    angular.element('#case-study-search-service').val('');
		    angular.element('#case-study-search-industry').val('');
		}
	}

    // module for case study tiles
	angular.module('component.caseStudyTile', [])
        .component('caseStudyTile', {
            bindings: {
                item: '='
            },
            transclude: true,
            templateUrl: '/App_Plugins/CaseStudy/Views/caseStudyTile.html',
            controller: caseStudyTileController
        })

	caseStudyTileController.$inject = ['$scope'];
	function caseStudyTileController($scope) {
	    var ctrl = this;
	    ctrl.hoverIn = function (event, color) {
	        var element = angular.element(event.srcElement || event.target);
	        if (!element.hasClass('text')) {
	            element = element.parent();
	        }

	        TweenLite.to(element, 0.5, { backgroundColor: color });

	        //element.css({ 'background-color': color });
	    }

	    ctrl.hoverOut = function (event) {
	        var element = angular.element(event.srcElement || event.target);
	        if (!element.hasClass('text')) {
	            element = element.parent();
	        }

	        TweenLite.to(element, 0.5, { backgroundColor: 'transparent' });
	        //element.css({ 'background-color': 'transparent' });
	    }
	}
})();       